import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectHasFiber, selectIsPreinstall } from '@app/redux';

import { DisconnectPageNavigationProps } from '../../index';
import DisconnectReason from './DisconnectReason';
import NewProvider from './NewProvider';
import { getSurveyOptions, OptionType } from './utils';

const Survey = ({ errorHandling }: { errorHandling: DisconnectPageNavigationProps['errorHandling'] }) => {
  const hasPreinstall = useSelector(selectIsPreinstall);
  const hasFiber = useSelector(selectHasFiber);

  const { t } = useTranslation('Disconnect');
  const asArray = { returnObjects: true };

  // Disconnect reasons
  const mainDisconnectReasons = getSurveyOptions(t, OptionType.Main, hasPreinstall, hasFiber);

  const otherDisconnectReasons = getSurveyOptions(t, OptionType.Other, hasPreinstall, hasFiber);

  // New providers
  const providersForActiveAccounts = hasFiber
    ? t('survey.fiber.active.provider.list', asArray)
    : t('survey.satellite.active.provider.list', asArray);

  const providersForPreinstallAccounts = hasFiber
    ? t('survey.fiber.preinstall.provider.list', asArray)
    : t('survey.satellite.preinstall.provider.list', asArray);

  const providerOptions = hasPreinstall ? providersForPreinstallAccounts : providersForActiveAccounts;

  return (
    <>
      <DisconnectReason
        errorHandling={errorHandling}
        mainSurveyOptions={mainDisconnectReasons}
        otherSurveyOptions={otherDisconnectReasons}
      />
      <NewProvider providerOptions={providerOptions} />
    </>
  );
};

export default Survey;
